import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRepeat} from "@fortawesome/free-solid-svg-icons";

export function Header(props) {
    return <div className={"header"} style={{display: "flex"}}>
        <h1>Logicle</h1>
        <button onClick={()=>props.onRetry()} className={"restart_button"}>New Problem <FontAwesomeIcon icon={faRepeat}/></button>
    </div>
}